var SplitPane = require('./lib/SplitPane');

module.exports = SplitPane;


//////////////////
// WEBPACK FOOTER
// ../~/react-split-pane/index.js
// module id = 1002
// module chunks = 0